export const style = {
  stack: {
    spacing: 2,
    sx: {
      width: 500,
    },
  },
  snackBar: {
    sx: {
      vertical: 'bottom',
      horizontal: 'left',
    },
  },
  alert: {
    severity: 'error',
    sx: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
} as const;
